import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultDeterminationProcess = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultDeterminationProcess' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <b> <center> Notice of Rights to Appeal Determination Process </center> </b>
                </p>
                <p className='w-750'>
                    <b>Our Philosophy </b> Jackson Hands of Change supports the rights of persons served  and their providers acting on a member"s behalf to appeal adverse clinical determinations.
                </p>
                <p className='w-750'>
                    <b>Our Policy</b> Our consumer organizations applicable federal and state laws impact the clinical appeals process. Therefore, the procedure for appealing a clinical determination is outlined fully in each healthy Louisiana plan, specific to Amerihealth, Aetna, Healthy Blue, Louisianan Healthcare Connections, and United Healthcare.
                </p>
                <p className='w-750'>
                    <b>What You Need to Do:</b>  To comply with the policy, your responsibility is- refer to Health Louisiana Plan provider, and adhere to the specific procedures for appealing a clinical determination; however
                    There is a deadline for All Appeals Process as indicated in your Healthy Louisiana plan providers manual.
                    Your Healthy Louisiana Plan provider must provide you and the provider gency of a requested denial. The provider or facility may only appeal on behalf of the member if they have obtained the member"s written consent.
                    Oral request for standard appeals must be followed by a written and signed request, unless expedited.
                </p>
                <p className='w-750'>
                    <b>Healthy Louisiana"s responsibility to the person served is:</b> Allow the person or person"s authorized representative to file an appeal after receiving the notice of action/denial/decision.  The appeal must be filed within the stated deadline specifically indicated by Amerihealth, Aetna, Healthy Blue, or United Healthcare as reflected in the Appeal process Provider manual.
                </p>
                <p className='w-750'>
                    In expediting the appeal process, contact your designated provider and convey the time it would take to complete a standard appeal with the potential of seriously jeopardizing the person"s life, health, or ability to attain, maintain or regain maximum function. In further expediting the appeals process you may contact your designated provided.
                </p>
                <p className='w-750'>
                    <b>
                        The Notice of Rights of Appeal Determination Process tells you how to appeal the process of denial of services through the Louisiana Behavioral Health Partnership. It is the agency"s obligation to provide informed consent of services offered, denied with the right to accept or refuse services.
                    </b>
                </p>
                <p className='w-750'>
                    <b></b>
                    I, <input type='text' id='txtDeterminationProcessName' name='txtDeterminationProcessName' className='add-only w-200 custom-add-only' /> , have been given a copy of the agency"s Notice of Rights of Appeal Determination Process and understand the contents and process.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}